<div [formGroup]="parentForm" class="select-field multiselect-field" style="{{ minWidth ? 'min-width:' +minWidth : ''}}">
  <mat-select [formControlName]="controlName" multiple [placeholder]="inputPlaceholder" (selectionChange)="onValueChanged($event)" panelClass="visits-designated-contacts">
    <mat-option *ngFor="let item of items" [value]="item.value">{{item.text}}</mat-option>
  </mat-select>
</div>
